import { DialogTitle } from '@headlessui/react'
import { useQueryClient } from '@tanstack/react-query'
import PropTypes from 'prop-types'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import {
  useNotificationContext,
  usePartnerContext,
  usePaymentContext
} from '../../context'
import { mutation } from '../../graphql'
import Button from '../tailwind/Button'
import Modal from '../tailwind/Modal'

const FullReset = ({ spaces, updateHandler, open, setOpen }) => {
  const { t } = useTranslation()
  const { is_trial } = usePaymentContext()
  const { success, error } = useNotificationContext()
  const { partner } = usePartnerContext()

  const queryClient = useQueryClient()

  const [isLoading, setIsLoading] = useState(false)

  const fullResetSpace = () => {
    setIsLoading(true)

    const resetSpace = ({ space_id }) => {
      // Verwende die mutation-Funktion
      return mutation({
        mutation: 'updateSpace',
        input: {
          id: space_id,
          owner: null, // Leerer String statt null
          progress: 0,
          updatedAt: new Date().toISOString()
        }
      })
    }

    Promise.all(spaces.map(({ id }) => resetSpace({ space_id: id })))
      .then(() => {
        if (is_trial) {
          queryClient.refetchQueries({
            queryKey: ['trial-data', partner.id],
            type: 'active'
          })
        }

        updateHandler()

        success(t('space_actions.full_reset_success'))
        setIsLoading(false)
        setOpen(false)
      })
      .catch((err) => {
        error()
        console.error(err)
        setIsLoading(false)
      })
  }

  return (
    <Modal open={open} setOpen={() => setOpen(false)} size='lg'>
      <DialogTitle className='text-center text-2xl font-medium leading-6 text-gray-900'>
        {t('space_actions.modal_full_reset_title')}
      </DialogTitle>
      <span className='mt-2 block text-center text-base text-gray-600'>
        {t('space_actions.modal_full_reset_description')}
      </span>
      <div className='mt-8 flex flex-row gap-3'>
        <Button.SecondaryXL
          fullWidth
          text={t('space_actions.modal_full_reset_cancel_action')}
          onClick={() => setOpen(false)}
        />
        <Button.PrimaryXL
          fullWidth
          text={
            spaces.length > 1
              ? t('space_actions.modal_full_reset_submit_action_multiple', {
                  count: spaces.length
                })
              : t('space_actions.modal_full_reset_submit_action_single')
          }
          onClick={fullResetSpace}
          isLoading={isLoading}
          className='bg-red-600 hover:bg-red-500'
        />
      </div>
    </Modal>
  )
}

FullReset.propTypes = {
  spaces: PropTypes.array.isRequired,
  updateHandler: PropTypes.func,
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired
}

FullReset.defaultProps = {
  updateHandler: () => undefined
}

export default FullReset
